import { ICoreServiceModel } from '../../../../service/common/model/ICoreServiceModel';
import { CoreRestCRUDService } from '../../../../service/coreCommon/common/rest/CoreRestCRUDService';
import { CTFConfigModule } from "../config/CTFConfigModule";

export abstract class CTFCoreRestCRUDService<ModelType extends ICoreServiceModel> extends CoreRestCRUDService<ModelType >{
    abstract getEndpoint(): string;

    protected getBaseAPIUrl: () => string = CTFConfigModule.getBaseAPIUrl
}